import { FormProvider as ReactHookFormProvider } from 'react-hook-form';
import { FormContext } from './CreatePersonaFormContext';
import type { UseCreatePersonaFormReturn } from '../hooks/useCreatePersonaForm';

interface CreatePersonaFormProviderProps {
  form: UseCreatePersonaFormReturn;
  children: React.ReactNode;
}

/**
 * Custom form provider that wraps react-hook-form's FormProvider
 * and exposes the full extended form return (including config like segmentNameOptions).
 */
export function CreatePersonaFormProvider({ form, children }: CreatePersonaFormProviderProps) {
  return (
    <FormContext.Provider value={form}>
      <ReactHookFormProvider {...form}>{children}</ReactHookFormProvider>
    </FormContext.Provider>
  );
}
